import React from 'react';
import { useState,useEffect } from "react";
import Swal from "sweetalert2";
import {Row,Col,Button} from "reactstrap";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { Cookies, useCookies } from 'react-cookie';
import { Link,useParams, useLocation } from 'react-router-dom';
import { checkDuplicateCustomerMain } from './CustomerMainUtils';
import {displayErrorToast,displayError,parseBoolean,findStateFromGstPortal,mapGstPortalCustomerFields,confirmGstDetails} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import LoadingOverlay from '../../components/LoadingOverlay';
import { updateCustomerMain,getCustomerMainDetails,searchGstin } from "../../services/CustomerMainServices";
import StatusDropDown from '../../components/StatusDropDown';
import { getAllSalesRepresentatives } from '../../services/SalesRepresentativeServices';
import { getAllGroups } from "../../services/GroupFormServices";
import TableRowsCustomer from './TableRowsCustomer';
import CustomerSitesTable from './CustomerSitesTable';
import { getIndianStates, DEFAULT_COUNTRY, DEFAULT_STATE } from '../../utils/PicklistProvider';
import AddressLocationFields, { ADDRESS_DEFAULTS } from '../../components/AddressLocationFields';
import Select from 'react-select';
import {  deleteCustomerSite } from "../../services/CustomerSiteServices";

function CustomerMainEdit() {
    const [cookies] = useCookies(['myToken']);
    const [inProgress, setInProgress] = useState(false);
    const [category] = useCookies(['myCategory']);
    const [superuser] = useCookies(['mySuperuser']);
    const [inputs, setInputs] = useState({
        name: '',
        legal_name: '',
        salesrep: '',
        address_1:'',
        address_2:'',
        address_3:'',
        pincode:'',
        country: ADDRESS_DEFAULTS.country,
        state: ADDRESS_DEFAULTS.state,
        district: ADDRESS_DEFAULTS.district,
        phone_number: '',
        mobile_number:'',
        email_id:'',
        credit_limit:0,
        customer_type:'',
        opening_balance_amt:0,
        opening_balance_date:'',
        customer_type:'',
        nature_of_business: '',
        is_interest_activated: '',
        is_bill_by_bill_maintained:'',
        default_credit:'',
        registration_type:'',
        is_gst_set:'',
        pan_no:'',
        gst_no:'',
        lut_no:'',
        tan_no:'',
        is_tcs_applicable:'',
        is_tds_deductible:'',
        contact_person:'',
        contact_designation:'',
        contact_mobile_no: '',
        contact_email_id:'',
        user_remarks:'',
        status: 'true'
       
    });
    const [error, setError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(true);
    const navigate = useNavigate();
    const [natBusiness, setnatBusiness] = React.useState([]);
    const [groups, setGroups] = React.useState([]);
    const [salesRep, setsalesRep] = React.useState([]);

  React.useEffect(() => {
    getAllSalesRepresentatives(cookies)
    .then (
        salesRepList => {
            
            const salesrep = salesRepList.salesrep_data.map(
              sales => {
                    return { value: sales.id, label: sales.entity_name }
                }
            );
            salesrep.sort((a, b) => a.label.localeCompare(b.label));
            setsalesRep(salesrep);
        }
    )
}, []);

useEffect( () => {
  getAllGroups(cookies)
  .then(response => {
const group =response.accounts_grouping_list.filter(obj => obj.entity_name == 'CUSTOMER TYPE' )
      const a =[]
                      for(var i=0; i<response.accounts_grouping_list.length; i++) 
                      {
                          if((response.accounts_grouping_list[i].parent_id)=== (group[0].id))
                          {
                              a.push(response.accounts_grouping_list[i]);
                          }
                      }
                     // Sort array `a` by `entity_name` in ascending order (A to Z)
a.sort((x, y) => x.entity_name.localeCompare(y.entity_name));
                      setGroups(a);
  });
}, []);

useEffect( () => {
  getAllGroups(cookies)
  .then(response => {
const group =response.accounts_grouping_list.filter(obj => obj.entity_name == 'NATURE OF BUSINESS' )
      const a =[]
                      for(var i=0; i<response.accounts_grouping_list.length; i++) 
                      {
                          if((response.accounts_grouping_list[i].parent_id)=== (group[0].id))
                          {
                              a.push(response.accounts_grouping_list[i]);
                          }
                      }
                     // Sort array `a` by `entity_name` in ascending order (A to Z)
a.sort((x, y) => x.entity_name.localeCompare(y.entity_name));
                      setnatBusiness(a);
  });

}, []);
const [rowsData, setRowsData] = useState([]);
 
const addTableRows = () => {
    const count=rowsData.length +1;

    const rowsInput={
      slNo:count,
      invoice_no: "",
      invoice_dt: "",
      invoice_amt: 0,
      payment_terms: 0,
      received_amt: 0,
      balance_amt: 0,
      mode: "debit"
        }
        setRowsData([...rowsData, rowsInput])
}
    
const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        for(var i=0; i<rows.length; i++) 
        {
            rows[i]['slNo']= i+1
        }
        setRowsData(rows);
}
const handleInvoice = (index, evnt)=>{

  const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
           if(name === 'invoice_amt')
          {
            console.log(JSON.stringify(name)+"name")
              var amount=value-rowsInput[index]['received_amt']
         
              rowsInput[index]['balance_amt']= amount
              console.log(JSON.stringify(rowsInput)+"rowsInput")
              var grandTotal = 0;
              for(var i=0; i<rowsData.length; i++) 
              {
     
                  if((rowsData[i].balance_amt) == '') 
                  {
                      rowsData[i].balance_amt=0 
                  
                  }
                  grandTotal += parseFloat(rowsData[i].balance_amt)
              }
          
          }
          else if(name === 'received_amt')
          {
  
              var amount=rowsInput[index]['invoice_amt']-value
        
              rowsInput[index]['balance_amt']= amount
              var grandTotal = 0;
              for(var i=0; i<rowsData.length; i++) 
              {
                 
                  if((rowsData[i].balance_amt) == '') 
                  {
                      rowsData[i].balance_amt=0
                    
                  }
                  grandTotal += parseFloat(rowsData[i].balance_amt)
              }
             
             
          }
          else if(name === 'balance_amt')
          {
             
          }
          setRowsData(rowsInput);
    }
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        try{
     
        if(name === 'name')   //Customer must not be empty if it is already exist u can create new product name
        {
            if(!value.trim())
            {
                setError(values => ({...values, [name]: "Customer Name must not be empty..."}))
                setIsSubmitting(false); 
            }
            else{
                      
                setError(values => ({...values, [name]: ""}))
                setIsSubmitting(true); 
              }
         
        }

          setInputs(values => ({...values, [name]: event.target.value}))
      
      }
      catch (e)
      {
       displayErrorToast(e);
      }
    }
    
    const validate_items = (name,value,regular_expr,error_message,obj) =>
    {
       try{
            if(value.trim())
            {
                if(!regular_expr.test(value.trim()))
                {
                    setError(values => ({...values, [name]: error_message}))
                    setIsSubmitting(false); 
                }
                else
                {
                    setError(values => ({...values, [name]: ''}))
                    setIsSubmitting(true);
                }
            }
            else
            {
                setError(values => ({...values, [name]: ''}))
                setIsSubmitting(true);
            }
            obj(values => ({...values, [name]: value}))
            if((name==='gst_no')&&(value.length === 15))
                  {
                    try {
                      searchGstin(cookies,(value))
                      .then( data => {
                        console.log(JSON.stringify(data)+"response data");
                        if (data.success && data.result) {
                          const mapped = mapGstPortalCustomerFields(data.result);
                          const st = findStateFromGstPortal(mapped.stcd, getIndianStates());
                          confirmGstDetails(data.result).then((result) => {
                            if (result.isConfirmed) {
                              setInputs(prev => ({
                                ...prev,
                                name: mapped.trade_name || prev.name,
                                legal_name: mapped.legal_name || prev.legal_name,
                                address_1: mapped.address_1 || prev.address_1,
                                address_2: mapped.address_2 || prev.address_2,
                                address_3: mapped.address_3 || prev.address_3,
                                pincode: mapped.pincode || prev.pincode,
                                state: st?.value || prev.state,
                                gst_status: mapped.gst_status || '',
                                registration_type: mapped.registration_type || '',
                                pan_no: value.substring(2, 12),
                              }));
                            }
                          });
                        }
                        else{
                          Swal.fire(`${data.message} for GST NO : ${value}` , '', 'info');
                        }
                      })
                      .catch((error) =>
                      {
                        displayError(error," Failed");
                      })
                    } 
                    catch (err) 
                    {
                        console.error("Error fetching GST details", err);
                        alert("Invalid or unreachable GST details.");
                    }
                  }
        }
       catch (e)
          {
           displayErrorToast(e);
          }
     }  

    const [siteData, setSiteData] = useState([]);
    const [siteInputs, setSiteInputs] = useState({});
    const [editIndex, setEditIndex] = useState(null); // null = add mode, number = edit mode
    const [showModal, setShowModal] = useState(false);
    const [isChecked,setIsChecked] = useState({chkbx:false})
      const openAddModal = () => {
          setSiteInputs({id:'',site_name: '',
            address_1:'',
            address_2:'',
            address_3:'',
            site_pincode:'',
            phone_number:'',
            mobile_number:'',
            site_email_id:'',
            radius_distance:0,
            project_name:'',
            contact_person:'',
            contact_designation: '',
            site_contact_email_id:'' ,
            user_remarks:'',
            contact_mobile_no:'',
            site_gst_no:'',
            site_pan_no:'',
            country: ADDRESS_DEFAULTS.country,
            state: ADDRESS_DEFAULTS.state,
            district: ADDRESS_DEFAULTS.district,
            status: 'true'});
          setEditIndex(null);
          setIsChecked(values => ({chkbx:false}))
          setShowModal(true);
      }
    
      const handleChangeSite = (e) => {
        const { name, value } = e.target;
        setSiteInputs((prev) => ({ ...prev, [name]: value }));
      };
    
      const handleModalClose = () => {
        if (siteInputs.site_name && siteInputs.state && siteInputs.radius_distance>0 && siteInputs.project_name) {
          if (editIndex !== null) {
            // Edit mode
            const updated = [...siteData];
            updated[editIndex] = { ...siteInputs, sl_no: editIndex + 1 };
            setSiteData(updated);
          } 
          else {
            // Add mode
            setSiteData([...siteData, { ...siteInputs, sl_no: siteData.length + 1 }]);
          }
          setShowModal(false);
          setSiteInputs({id:'',site_name: '',
          address_1:'',
          address_2:'',
          address_3:'',
          site_pincode:'',
          phone_number:'',
          mobile_number:'',
          site_email_id:'',
          radius_distance:0,
          project_name:'',
          contact_person:'',
          contact_designation: '',
          site_contact_email_id:'' ,
          user_remarks:'',
          contact_mobile_no:'',
          status: 'true',
          site_gst_no:'',
          site_pan_no:'',
          country: ADDRESS_DEFAULTS.country,
          state: ADDRESS_DEFAULTS.state,
          district: ADDRESS_DEFAULTS.district});
          setEditIndex(null);
        }
        else{
          Swal.fire("Name,State,Radius Distance ,Project name are mandatory.", "", "info");
        }
      };

      const openEditModal = (index) => {
        setSiteInputs({ ...siteData[index] });
        setEditIndex(index);
        setIsChecked({ chkbx: false });
        setShowModal(true);
      };
    
      const deleteTableSiteRows = (index)=>{
        const rows = [...siteData];
        if(rows[index]['id']){
    Swal.fire({title: 'Are you sure to Delete?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,  
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        // setIsLoading(true);
        deleteCustomerSite(cookies, rows[index]['id'])
        .then(response => {
            console.log(`consignee with id ${rows[index]['id']} deleted`);
            rows.splice(index, 1);
            rows.forEach((row, idx) => (row.sl_no = idx + 1));
            setSiteData(rows);
            Swal.fire('Deleted Successfully!', '', 'success');
        })
        .catch(error => {
            console.log(error.response.data);
            displayError(error.response.data,'Delete Failed');
        }); 
      } else if (result.isDismissed) {    
        Swal.fire('Not Deleted', '', 'info')  
    }
    });
        }
        else{
          rows.splice(index, 1);
          rows.forEach((row, idx) => (row.sl_no = idx + 1));
          setSiteData(rows);
        }
      }

      const handleCopyDetails = (event) => {
          const name = event.target.name;
          const value = event.target.checked;
          try{    
            if(value === true){
              setIsChecked(values => ({chkbx:true}))
              setSiteInputs(values =>({...values,
              ['site_name']: inputs.name,
              ['address_1']:inputs.address_1,
              ['address_2']:inputs.address_2,
              ['address_3']:inputs.address_3,
              ['site_pincode']:inputs.pincode,
              ['phone_number']:inputs.phone_number,
              ['mobile_number']:inputs.mobile_number,
              ['site_email_id']:inputs.email_id,
              ['site_pan_no']:inputs.pan_no,
              ['site_gst_no']:inputs.gst_no,
              ['country']:inputs.country || DEFAULT_COUNTRY,
              ['state']:inputs.state,
              ['district']:inputs.district || ''
              }))
            }
            else
            {
              const emptyvalues = {
                site_name: '',
                address_1:'',
                address_2:'',
                address_3:'',
                site_pincode:'',
                phone_number:'',
                mobile_number:'',
                site_email_id:'',
                site_pan_no:'',
                site_gst_no:'',
                country: DEFAULT_COUNTRY,
                state: DEFAULT_STATE,
                district: ''
              };
              setIsChecked(values => ({chkbx:false}))
              setSiteInputs(values => ({...values, ...emptyvalues}));
            }
          } 
          catch(e)
          {
            displayErrorToast(e);
          }  
        }
     const handleSubmit=(event)=> {
      event.preventDefault();
        checkDuplicateCustomerMain(event.target.name.name, event.target.name.value, cookies, id)
      .then(isNameExists => {
        if (isNameExists) {
          setError(values => ({...values, [event.target.name.name]: 'Customer name already exists.'}))
        } else {
          if (Object.values(error).every((x) => !x) && isSubmitting && siteData.length>0) { 
      //If the fields are correct details it is valid choosing yes or no option,otherwise it is invalid
              Swal.fire({title: 'Do you want to update?',  
              showCancelButton: true,  
              confirmButtonText: `Yes`,  
              cancelButtonText: `No`,
              }).then((result) => {  
                if (result.isConfirmed) { 
                    console.log(JSON.stringify(inputs)+"inputsubmit")
                    updateCustomerMain(cookies, {
                      gst_status:inputs.gst_status,
                      id:inputs.id,
                      name:inputs.name,
                      legal_name:inputs.legal_name || '',
                      salesrep_id:inputs.salesrep_id,
                      address_1:inputs.address_1,
                      address_2:inputs.address_2,
                      address_3:inputs.address_3,
                      pincode:inputs.pincode,
                      country: inputs.country || DEFAULT_COUNTRY,
                      state: inputs.state,
                      district: inputs.district || '',
                      phone_number: inputs.phone_number,
                      mobile_number:inputs.mobile_number,
                      email_id:inputs.email_id,
                      credit_limit:parseInt(inputs.credit_limit),
                      opening_balance_amt:parseInt(inputs.opening_balance_amt),    
                      opening_balance_date:inputs.opening_balance_date,
                      customer_type_id:inputs.customer_type_id,
                      nature_of_business_id: inputs.nature_of_business_id,
                      is_interest_activated: inputs.is_interest_activated,
                      is_bill_by_bill_maintained:inputs.is_bill_by_bill_maintained,
                      default_credit:inputs.default_credit,
                      registration_type:inputs.registration_type,
                      is_gst_set:inputs.is_gst_set,
                      pan_no:inputs.pan_no,
                      gst_no:inputs.gst_no,
                      lut_no:inputs.lut_no,
                      tan_no:inputs.tan_no,
                      is_tcs_applicable:parseBoolean(inputs.is_tcs_applicable),
                      is_tds_deductible:parseBoolean(inputs.is_tds_deductible),
                      contact_person:inputs.contact_person,
                      contact_designation: inputs.contact_designation,
                      contact_mobile_no: inputs.contact_mobile_no,
                      contact_email_id:inputs.contact_email_id,
                      user_remarks:inputs.user_remarks,
                      ob_details_list:rowsData.map(cuslist=>({
                        id:cuslist.id,
                        invoice_no:cuslist.invoice_no,
                        invoice_dt:cuslist.invoice_dt,
                        invoice_amt:parseInt(cuslist.invoice_amt),
                        payment_terms:cuslist.payment_terms,
                        received_amt:cuslist.received_amt,
                        balance_amt:cuslist.balance_amt,
                        mode:cuslist.mode
                      })),
                      site_list:siteData.map(site=>({
                        id:site.id,
                        name: site.site_name.trim().toUpperCase(),
                        address_1:site.address_1,
                        address_2:site.address_2,
                        address_3:site.address_3,
                        pincode:site.site_pincode,
                        phone_number:site.phone_number,
                        mobile_number:site.mobile_number,
                        email_id:site.site_email_id,
                        radius_distance:site.radius_distance,
                        project_name:site.project_name,
                        contact_person:site.contact_person,
                        contact_designation: site.contact_designation,
                        contact_email_id: site.site_contact_email_id,
                        user_remarks:site.user_remarks,
                        contact_mobile_no:site.contact_mobile_no,
                        status: parseBoolean(site.status),
                        country:site.country || DEFAULT_COUNTRY,
                        state:site.state,
                        district:site.district || '',
                        gst_no:site.site_gst_no?site.site_gst_no:'',
                        pan_no:site.site_pan_no?site.site_pan_no:''
                      })),
                      status:parseBoolean(inputs.status)
                   }, id)
                  .then(response => {
                      Swal.fire("Updated!", "", "success");
                      Reload();
                  }).catch((error) => {
                      console.log(error.response.data);
                      displayError(error.response.data,"Updated Failed");
                  });
                  
                } 
                else if (result.isDismissed) {
                  Swal.fire("Not Updated", "", "info");
                }
              });
        }
        else if(siteData.length == 0){
              Swal.fire("Atleast 1 site must be added", "", "info");
            }
  }
  });
   } 

        const Reload = () => {
          navigate('/CustomerMainTable')
        }      
        const view = () => {
          navigate('/CustomerMainTable')
        }  
        const Back = () => {
          navigate('/Home')
        }
        const Cancel = () => {
            setInputs({
              name: '',
              salesrep: '',
              address_1:'',
              address_2:'',
              address_3:'',
              pincode:'',
              country: ADDRESS_DEFAULTS.country,
              state: ADDRESS_DEFAULTS.state,
              district: ADDRESS_DEFAULTS.district,
              phone_number: '',
              mobile_number:'',
              email_id:'',
              credit_limit:0,
              opening_balance_amt:0,
              opening_balance_date:'',
              customer_type_id:'',
              nature_of_business_id: '',
              is_interest_activated: '',
              is_bill_by_bill_maintained:'',
              default_credit:'',
              registration_type:'Unknown',
              is_gst_set:'',
              pan_no:'',
              gst_no:'',
              lut_no:'',
              tan_no:'',
              is_tcs_applicable:'false',
              is_tds_deductible:'false',
              contact_person:'',
              contact_designation:'',
              contact_mobile_no: '',
              contact_email_id:'',
              user_remarks:'',
              status: 'true'
            });
        }
  
      const {id}=useParams()
      const location = useLocation();
      React.useEffect(() => {
        if (id) {
          setInProgress(true);
          getCustomerMainDetails(cookies, id)
            .then(siteObject => {
              setInProgress(false);
              setInputs({...siteObject,
                country: siteObject.country || DEFAULT_COUNTRY,
                district: siteObject.district || '',
                salesrep_id:siteObject.salesrep.id,
                customer_type_id:siteObject.customer_type.id,
                is_tcs_applicable:siteObject.is_tcs_applicable,
                nature_of_business_id:siteObject.nature_of_business.id});
                setselectedSalesrep ({value:siteObject.salesrep.id,label:siteObject.salesrep.name})
                setRowsData(siteObject.ob_details_list.map((cuslist,index)=>({...cuslist,slNo: index+1})));
              setSiteData((siteObject.consignees || []).map(site => ({
                ...site,
                country: site.country || DEFAULT_COUNTRY,
                district: site.district || '',
              })))
            })
            .catch(error => {
              setInProgress(false);
              //displayError(error.response.data, "Loading Failed");
              console.log(error+"error")
            });
          }
        }, [id, location.state?.reloadCustomer]);
        const [selectedSalesrep, setselectedSalesrep] = useState(null);
        const onSalesrepSelect = (selected) => {
          setselectedSalesrep(selected);
          setInputs(values => ({...values,['salesrep_id']:selected.value}))
      };
    return (
    <>
     <div id="outer-container"  className="App" > 
        <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
        <ErrorToast/>
        <LoadingOverlay inProgress={inProgress}/>
        <div id="page-wrap">
        <form onSubmit={handleSubmit}> 
          <div className="container">
            <PremiumPageHeader
              module="MARKETING"
              title="Update Customer Registration"
              subtitle="Edit customer billing details, statutory information, and contacts."
              modeLabel="EDIT MODE"
            />
          </div>

          <FloatingControls
            tableLink="/CustomerMainTable"
            formLink="/CustomerMain"
            addNewLabel="New Customer"
            onCancel={Cancel}
            enableCancel={true}
          />
          <div className="container form-control-panel">
                <Row> 
                <Col xl={6} lg={12} md={12}>   
                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                <h5 className='col-sm-11'><b>Customer Details</b></h5><br/><br/> 
                                <label htmlFor="name" className="form-group col-sm-4 text-right">Name </label>
                                <input type="text" name="name" id="name" className="form-control col-sm-7 mandatory-form-control" required onChange={handleChange} value={inputs.name || ""} placeholder="Enter fill the name field*"   maxLength="100" /><br/>
                                {error.name && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.name}</strong><br/></>)}

                                <label htmlFor="legal_name" className="form-group col-sm-4 text-right">Legal Name</label>
                                <input type="text" name="legal_name" id="legal_name" className="form-control col-sm-7" onChange={handleChange} value={inputs.legal_name || ""} placeholder="GST registered legal name" maxLength="200" /><br/>

                                <label htmlFor="salesrep_id" className="form-group col-sm-4 text-right">Marketing Name </label>
                                <div style={{width: '58%'}} >
                                <Select
                                id="salesrep_id"
                                  options={salesRep}
                                  isMulti= {false}
                                  isSearchable={true}
                                  value={selectedSalesrep}
                                  onChange={onSalesrepSelect}
                                  className={"mandatory-form-control react-select-dropdown"}
                                />
                                </div> 
                                <br/>
                                
                                <label htmlFor="address_1" className="form-group col-sm-4 text-right">Address</label>
                                <input type="text" name="address_1" id="address_1" className="form-control col-sm-7" onChange={handleChange} value={inputs.address_1 || ""}/><br/>
                                
                                <label htmlFor="address_2" className="form-group col-sm-4 text-right"></label>
                                <input type="text" name="address_2" id="address_2" className="form-control col-sm-7" onChange={handleChange} value={inputs.address_2 || ""}/><br/>
                                
                                <label htmlFor="address_3" className="form-group col-sm-4 text-right"></label>
                                <input type="text" name="address_3" id="address_3" className="form-control col-sm-7" onChange={handleChange} value={inputs.address_3 || ""}/><br/>                                       
                                
                                <label htmlFor="pincode"className="form-group col-sm-4 text-right  ">Pin Code</label>
                                <input name="pincode" id="pincode" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid Pincode",setInputs)} value={inputs.pincode || ""} className="form-control col-sm-7" type = "text" maxLength="6" /><br/>
                                {error.pincode && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pincode}</strong><br/></>)}

                                <AddressLocationFields
                                  values={{ country: inputs.country, state: inputs.state, district: inputs.district }}
                                  onFieldChange={handleChange}
                                  error={error}
                                />

                                <label htmlFor="phone_number" className="form-group col-sm-4 text-right">Phone No</label>
                                <input type="text" name="phone_number" id="phone_number" className="form-control col-sm-7" onChange={handleChange} value={inputs.phone_number || ""}placeholder="0123456789, 0123456789" /><br/>
                                
                                <label htmlFor="mobile_number" className="form-group col-sm-4 text-right">Mobile No</label>
                                <input type="text" name="mobile_number" id="mobile_number" className="form-control col-sm-7"  onChange={handleChange} value={inputs.mobile_number || ""} placeholder="0123456789, 0123456789"/><br/>
                                
                                <label htmlFor="email_id" className="form-group col-sm-4 text-right">Email</label>
                                <input type="email" name="email_id" id="email_id" className="form-control col-sm-7"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid Emailid",setInputs)} value={inputs.email_id|| ""} /><br/>
                                {error.email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.cusEmailid}</strong><br/></>)}

                                <label htmlFor="credit_limit" className="form-group col-sm-4 text-right">Credit Limit(in Rs.)</label>
                                <input type="number" name="credit_limit" id="credit_limit" onChange={handleChange} value={inputs.credit_limit || 0} className="form-control col-sm-7"/>

                                <label htmlFor="opening_balance_amt" className="form-group col-sm-4 text-right">Opening Balance Amount</label>
                                <input type="number" name="opening_balance_amt" id="opening_balance_amt" onChange={handleChange} value={inputs.opening_balance_amt || 0} className="form-control col-sm-6"/>
                                <button type="button"  className="btn btn-primary text-blue text-bold " data-toggle="modal" data-target="#exampleModalCenter">Details</button>
                                <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                <div className="modal-dialog modal-lg" style={{height: "500px"}} >
                                  <div className="modal-content">
                                      <div className="modal-body display">
                                        <table id="example mytable" className="table-responsive">
                                            <thead>
                                                <tr>                                                    
                                                <th><button type="button"className="btn btn-success" onClick={addTableRows}>+</button></th>
                            <th colSpan="1">S.No.</th>
                            <th colSpan="1">Invoice No</th>
                            <th colSpan="1" style={{width:"120px"}}>Invoice Date</th>
                            <th colSpan="1">Invoice Amount</th>
                            <th colSpan="1">Payment Terms</th>
                            <th colSpan="1">Received Amount </th>
                            <th colSpan="1">Balance Amount</th>
                            <th colSpan="1">Mode</th>
                                                    </tr>
                                                    </thead>
                                            <tbody id="tbodymodal">
                                         
                                              <TableRowsCustomer rowsData={rowsData} deleteTableRows={deleteTableRows} handleInvoice={handleInvoice} />
                                            </tbody>
                                      
                                        </table>
                                      </div>
                                  </div>
                                </div>
                        </div>


                                <label htmlFor="opening_balance_date"className="form-group col-sm-4 text-right "> Opening  Balance Date </label>
                                <input type="date" id="opening_balance_date" name="opening_balance_date" onChange={handleChange} value={inputs.opening_balance_date || ""}className="form-control col-sm-7 " />
                        </div>
                        
                        <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                        <h5 className='col-sm-11'><b>Customer Type Details</b></h5><br/><br/> 
                                <label htmlFor="customer_type_id" className="form-group col-sm-4 text-right">Customer Type </label>
                                <select id="customer_type_id" name="customer_type_id" onChange={handleChange} value={inputs.customer_type_id || ""} className="browser-default custom-select form-control col-sm-7 mandatory-form-control" required>
                                    {groups.map((item) => (
                                    <option key={item.id} value={item.id}>
                                    {item.entity_name}
                                    </option>
                                ))}
                                </select><br/>
                    
                                <label htmlFor="nature_of_business_id" className="form-group col-sm-4 text-right">Nature of Business </label>
                                <select name="nature_of_business_id" id="nature_of_business_id" onChange={handleChange} value={inputs.nature_of_business_id || ""} className="browser-default custom-select form-control col-sm-7 mandatory-form-control" required>
                                    <option value="">Select Customer's Nature of Business </option>
                                    {natBusiness.map((item) => (
                                    <option key={item.id} value={item.id}>
                                    {item.entity_name}
                                    </option>
                                ))}
                                </select><br/>

                                <label htmlFor="is_interest_activated" className="form-group col-sm-4 text-right">Activate interest</label>
                                <select name="is_interest_activated" id="is_interest_activated" onChange={handleChange} value={inputs.is_interest_activated || ""} className="browser-default custom-select form-control col-sm-7 " required >
  
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                                </select><br/>

                                <label htmlFor="is_bill_by_bill_maintained" className="form-group col-sm-4 text-right">Maintain Bill-by-bill</label>
                                <select name="is_bill_by_bill_maintained" id="is_bill_by_bill_maintained" onChange={handleChange} value={inputs.is_bill_by_bill_maintained} className="browser-default custom-select form-control col-sm-7"  >
  
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                                </select><br/>

                                <label htmlFor="default_credit" className="form-group col-sm-4 text-right">Credit(in Days)</label>
                                <input type="number" name="default_credit" id="default_credit" onChange={handleChange} value={inputs.default_credit || 0} className="form-control col-sm-7"/><br/>
                                
                             
                        </div>
                </Col>
                    <Col xl={6} lg={12} md={12}>   
 
                   
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                    <h5 className='col-sm-11'><b>Statutory Details</b></h5><br/><br/> 
                    <label htmlFor="registration_type" className="form-group col-sm-4 text-right">GST Type </label>
                                <select name="registration_type" id="registration_type" onChange={handleChange} value={inputs.registration_type || ""} className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                                <option value="Unknown">Unknown</option>
                                <option value="Composition">Composition</option>
                                <option value="Consumer">Consumer</option>
                                <option value="Regular">Regular</option>
                                <option value="Unregistered">Unregistered</option>
                                </select><br/>
                    
                                <label htmlFor="is_gst_set" className="form-group col-sm-4 text-right">Set/Alter GST details</label>
                                <select name="is_gst_set" id="is_gst_set" onChange={handleChange} value={inputs.is_gst_set} className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                                <option value="">Please select</option> 
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                                </select><br/>
                            <label htmlFor="pan_no" className="form-group col-sm-4 text-right">PAN No.</label>
                            <input type="text"name="pan_no" id="pan_no" className="form-control col-sm-7" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,"invalid PANNo",setInputs)}  value={inputs.pan_no || ""}  placeholder="Please fill the PAN field *"  /><br/>
                            {error.pan_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pan_no}</strong><br/></>)}
                            

                            <label htmlFor="gst_no"className="form-group col-sm-4 text-right  ">GST No </label>
                            <input type="text" id="gst_no" name="gst_no" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,"invalid GSTNo",setInputs)}  value={inputs.gst_no || ""}className="form-control col-sm-7 "  placeholder="Please fill the Gst field *" /><br/>
                            {error.gst_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.gst_no}</strong><br/></>)}

                            <label htmlFor="gst_status"className="form-group col-sm-4 text-right">GST Status</label>
                            <input name="gst_status" id="gst_status"  value={inputs.gst_status || ""} style={{cursor:"not-allowed"}}className="form-control col-sm-7" disabled={true} type = "text" /><br/>
                            
                            <label htmlFor="lut_no" className="form-group col-sm-4 text-right">LUT No</label>
                            <input type="text" name="lut_no" id="lut_no"  onChange={handleChange} 
                            value={inputs.lut_no|| ""}className="form-control col-sm-7 " /><br/>
                            
                            <label htmlFor="tan_no" className="form-group col-sm-4 text-right">TAN No.</label>
                            <input type="text" name="tan_no" id="tan_no" onChange={handleChange} 
                            value={inputs.tan_no || ""}className="form-control col-sm-7 "  /><br/>

                            <label htmlFor="is_tcs_applicable" className="form-group col-sm-4 text-right">Is TCS Applicable </label>
                                <select name="is_tcs_applicable" id="is_tcs_applicable"  onChange={handleChange} value={inputs.is_tcs_applicable } className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                                </select><br/>

                                
                            <label htmlFor="is_tds_deductible" className="form-group col-sm-4 text-right">Is TDS Deductable </label>
                                <select name="is_tds_deductible" id="is_tds_deductible" onChange={handleChange} value={inputs.is_tds_deductible || ""} className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                                </select><br/>
                            
                        </div>
                        
                        <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                        <h5 className='col-sm-11'><b>Contact Details</b></h5><br/><br/> 
                            <label htmlFor="contact_person" className="form-group col-sm-4 text-right">Contact Person Name</label>
                            <input type="text" name="contact_person" id="contact_person" onChange={handleChange} value={inputs.contact_person || ""} className="form-control col-sm-7"/><br/>
                            
                            <label htmlFor="contact_designation" className="form-group col-sm-4 text-right">Designation</label>
                            <input type="text" name="contact_designation" id="contact_designation" onChange={handleChange} value={inputs.contact_designation || ""} className="form-control col-sm-7"/><br/>
                            
                            <label htmlFor="contact_mobile_no" className="form-group col-sm-4 text-right">Contact Mobile No</label>
                            <input type="text" name="contact_mobile_no" id="contact_mobile_no"  onChange={handleChange} value={inputs.contact_mobile_no || ""} placeholder="0123456789"  className="form-control col-sm-7"/><br/>
                            
                            <label htmlFor="contact_email_id" className="form-group col-sm-4 text-right">Email Id</label>
                            <input type="email" name="contact_email_id" id="contact_email_id" onChange={handleChange} value={inputs.contact_email_id || ""} className="form-control col-sm-7" placeholder="ABC@gmail.com"/><br/>
                            {error.contact_email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.contact_email_id}</strong><br/></>)}
                        </div>

                        <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                        <h5 className='col-sm-11'><b>Status Details</b></h5><br/><br/> 
                            <label htmlFor="user_remarks" className="form-group col-sm-4 text-right">Remarks</label>
                            <textarea rows="4" cols="50" className="form-control col-sm-7" id="user_remarks" name="user_remarks" onChange={handleChange} value={inputs.user_remarks || ""}></textarea>
                            <StatusDropDown status={inputs.status} onChange={handleChange}/>
                            <br/>
                        </div>
                    </Col>
                </Row>             
            </div>
            <div className="container">
                <Row>
                <Col xl={12} lg={24} md={24}>
             
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                      <CustomerSitesTable
                        siteData={siteData}
                        onAdd={openAddModal}
                        onDelete={deleteTableSiteRows}
                        onEdit={openEditModal}
                        showSiteCount
                        customerName={inputs.name || ''}
                        cookies={cookies}
                      />
                      <div className="modal" tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                                            <div className="modal-dialog modal-xl" style={{ height: "500px"}}>
                                              <div className="modal-content">
                                                <div className="modal-body display" style={{backgroundColor:"pink" }}>
                                                  <Row> 
                                                    <Col xl={6} lg={12} md={12}> 
                                                      <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                                        <label htmlFor="chkbx" className="form-group col-sm-4 text-right">Same as Customer</label>
                                                        <label>
                                                        <input type="checkbox" id="copycustomerdetails"  name="copycustomerdetails" onChange={(evnt)=>(handleCopyDetails(evnt))} checked={isChecked.chkbx || false}/></label>
                                    
                                                        <h5 className='col-sm-11'><b>Site Details</b></h5><br/><br/>
                                                        <label htmlFor="site_name" className="form-group col-sm-4 text-right">Name </label>
                                                        <input type="text" id='site_name' name="site_name" className="form-control col-sm-7 mandatory-form-control" placeholder="Please fill the name field *"  onChange={handleChangeSite} value={siteInputs.site_name || ""}/>
                                                        {error.site_name && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_name}</strong><br/></>)}
                            
                                                        <label htmlFor="address_1" className="form-group col-sm-4 text-right">Address </label>
                                                        <input type="text" id='address_1' name="address_1"onChange={handleChangeSite} value={siteInputs.address_1 || ""} className="form-control  col-sm-7" />
                                                                                  
                                                        <label htmlFor="address_2" className="form-group col-sm-4 text-right"></label>
                                                        <input type="text" id='address_2' name="address_2" onChange={handleChangeSite} value={siteInputs.address_2 || ""}className="form-control  col-sm-7" />
                                                      
                                                        <label htmlFor="address_3" className="form-group col-sm-4 text-right"></label>
                                                        <input type="text" id='address_3' name="address_3" onChange={handleChangeSite} value={siteInputs.address_3 || ""}className="form-control  col-sm-7" />
                                                      
                                                        <label htmlFor="site_pincode" className="form-group col-sm-4 text-right">Pincode</label>
                                                        <input name="site_pincode" id="site_pincode" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid pincode",setSiteInputs)} value={siteInputs.site_pincode || ""} className="form-control col-sm-7" type = "text" maxLength="6" />
                                                        {error.site_pincode && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_pincode}</strong><br/></>)}

                                                        <AddressLocationFields
                                                          idPrefix="site_"
                                                          values={{ country: siteInputs.country, state: siteInputs.state, district: siteInputs.district }}
                                                          onFieldChange={handleChangeSite}
                                                          error={error}
                                                        />
                                                    
                                                        <label htmlFor="phone_number" className="form-group col-sm-4 text-right">Phone No</label>
                                                        <input type="text" id='phone_number' name="phone_number"onChange={handleChangeSite} value={siteInputs.phone_number || ""} placeholder="0123456789" className="form-control  col-sm-7"/>
                                                      
                                                        <label htmlFor="mobile_number" className="form-group col-sm-4 text-right">Mobile No</label>
                                                        <input type="text" id='mobile_number' name="mobile_number" onChange={handleChangeSite} value={siteInputs.mobile_number || ""} placeholder="0123456789"className="form-control  col-sm-7"/>
                                                                                  
                                                        <label htmlFor="site_email_id" className="form-group col-sm-4 text-right">Email</label>
                                                        <input type="site_email" id="site_email_id" name="site_email_id"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid cusEmailid",setSiteInputs)} value={siteInputs.site_email_id|| ""} className="form-control col-sm-7 " />
                                                        {error.site_email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_email_id}</strong><br/></>)}
                                                      </div>
                                                    </Col>
                                                    <Col xl={6} lg={12} md={12}> 
                                                      <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                                        <h5 className='col-sm-11'><b>Site Contact Details</b></h5><br/>
                                                        <label htmlFor="radius_distance" className="form-group col-sm-4 text-right">Radial Distance(1 Way) </label>
                                                        <input type="number" id="radius_distance"name="radius_distance" onChange={handleChangeSite} value={siteInputs.radius_distance || 0} className="form-control  col-sm-7 mandatory-form-control" />
                                                                              
                                                        <label htmlFor="project_name" className="form-group col-sm-4 text-right">Project Name </label>
                                                        <input type="text" name="project_name" id="project_name"onChange={handleChangeSite} value={siteInputs.project_name || ""} className="form-control  col-sm-7 mandatory-form-control" placeholder="Please fill the project name field *" />
                                                        
                                                        <label htmlFor="contact_person" className="form-group col-sm-4 text-right">Contact Person</label>
                                                        <input type="text" id='contact_person'name="contact_person"onChange={handleChangeSite} value={siteInputs.contact_person || ""} className="form-control  col-sm-7"/>
                                                        
                                                        <label htmlFor="contact_designation" className="form-group col-sm-4 text-right">Designation</label>
                                                        <input type="text"id='contact_designation' name="contact_designation"onChange={handleChangeSite} value={siteInputs.contact_designation || ""} className="form-control  col-sm-7"/>
                                      
                                                        <label htmlFor="site_contact_email_id" className="form-group col-sm-4 text-right">Email</label>
                                                        <input type="text" id='site_contact_email_id' name="site_contact_email_id"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid CuscontactEmailId",setSiteInputs)} value={siteInputs.site_contact_email_id || ""}className="form-control  col-sm-7"/>
                                                        {error.site_contact_email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_contact_email_id}</strong><br/></>)}
                      
                                                        <label htmlFor="contact_mobile_no" className="form-group col-sm-4 text-right" >Mobile No</label>
                                                        <input type="text" id='contact_mobile_no' name="contact_mobile_no"onChange={handleChangeSite} value={siteInputs.contact_mobile_no || ""} placeholder="0123456789" className="form-control  col-sm-7"/>
                                                        
                                                        <h5 className='col-sm-11'><b>Statutory Details</b></h5><br/>
                                                        <label htmlFor="site_pan_no" className="form-group col-sm-4 text-right">PAN No.</label>
                                                        <input type="text"name="site_pan_no" id="site_pan_no" className="form-control col-sm-7" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,"invalid PANNo",setSiteInputs)}  value={siteInputs.site_pan_no || ""}  placeholder="Please fill the PAN field *"  /><br/>
                                                        {error.site_pan_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_pan_no}</strong><br/></>)}
                      
                                                        <label htmlFor="site_gst_no"className="form-group col-sm-4 text-right">GST No </label>
                                                        <input type="text" id="site_gst_no" name="site_gst_no" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,"invalid GSTNo",setSiteInputs)}  value={siteInputs.site_gst_no || ""}className="form-control col-sm-7 "  placeholder="Please fill the Gst field *" /><br/>
                                                        {error.site_gst_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_gst_no}</strong><br/></>)}
                      
                                                        <label htmlFor="user_remarks" className="form-group col-sm-4 text-right">Remarks</label>
                                                        <input type="text" name="user_remarks" onChange={handleChangeSite} value={siteInputs.user_remarks || ""}className="form-control  col-sm-7" placeholder="IF ANY.."/>
                                                        
                                                        <StatusDropDown status={siteInputs.status} onChange={handleChangeSite}/><br/>
                                                      </div> 
                                                    </Col>
                                                  </Row>                   
                                                </div>
                                                <div className="text-center" style={{backgroundColor:"pink" }}>
                                                  <button type="button" className="btn btn-primary" onClick={handleModalClose}>
                                                    {editIndex !== null ? "Update" : "Add"}
                                                  </button>
                                                  <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>Close</button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                  </div>
                </Col>
                </Row>
              </div>
            <div className="footer company-form-footer text-center">
              
            <Button  type="submit"  style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(42,245,39,0.8)"}} className="btn btn-twitter company-form-action-btn"><i className="fa fa-floppy-o" aria-hidden="true" /> Update</Button> &nbsp;&nbsp;

                  <Button  type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter company-form-action-btn" onClick={view}><i className="fa fa-eye" aria-hidden="true" /> View</Button>&nbsp;&nbsp;
                  <Button  type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter company-form-action-btn" onClick={Back}><i className="fa fa-home" aria-hidden="true" /> Home</Button>
            </div>
        </form>
        </div>
    </div>
         </>
    );
  }
  export default CustomerMainEdit;